import axios from "axios";

const BASE_URL = "/api/services/app/Terms";

export async function getTermsDatesForAdmin() {
    const response = await axios.get(`${BASE_URL}/GetTermsDatesForAdmin`);
    return response.data.result;
}

export async function updateTermsLastUpdatedDate(categoryKey) {
    const response = await axios.put(`${BASE_URL}/UpdateTermsLastUpdatedDate`, {
        categoryKey: categoryKey,
        newDate: null
    });
    return response.data.result;
}

export async function getAllTermsDates() {
    const response = await axios.get(`${BASE_URL}/GetAllTermsDates`);
    return response.data.result.termsDates;
}
